import ConfiguracoesService from '@/services/ConfiguracoesService.js';
import ConciliacoesService from '@/services/ConciliacoesService.js';
import ArquivosService from '@/services/ArquivosService.js';
import randomString from '@/utils/generateRandomString';
import tourMixins from '@/mixins/tourMixins';

export default {
  mixins: [tourMixins],

  props: {
    conciliacao: {
      type: Object,
      default: () => {}
    },
    tab: {
      type: Number,
      required: true
    }
  },

  data() {
    return {
      titulo: '',
      tucsList: ['125', '135', '160', '190', '210', '255', '295', '330', '340', '345', '395', '565', '570', '575', '580'],
      atributosList: [
        'ODI',
        'TI',
        'A1',
        'A2',
        'A3',
        'A4',
        'A5',
        'A6',
        'Data',
        'Periodo',
        'UAR',
        'IDUC',
        'Inventario',
        'Obra',
        'Material',
        'Generico_1',
        'Generico_2',
        'Generico_3'
      ],
      prioridades: ['TUC'],
      rodadas: [{ key: '1', valores: ['TUC'] }],
      tucSelecionada: '',
      flexibilidade: 'Flexível',
      tipoConciliacao: '',
      atributosCoringa: false,
      partidaReferencia: {
        partida: this.getDefaultPartidaReferencia('partida'),
        referencia: this.getDefaultPartidaReferencia('referência')
      },
      panels: undefined,
      relatoriosDialog: false,
      dialogFlexibilidade: false,
      dialogAtributosCoringa: false,
      loading: false,
      tempoEstimado: null,
      mockTempoEstimadoTour: false,
      arrPrimeiraTabTour: [
        {
          element: '#titulo-conciliacao',
          intro: 'Aqui você deve inserir um nome para sua conciliação.',
          scrollTo: 'tooltip',
          position: 'right'
        },
        {
          element: '#tuc-selecionada-conciliacao',
          intro: 'Aqui você deve selecionar uma TUC para sua conciliação.',
          scrollTo: 'tooltip',
          position: 'right'
        },
        {
          element: '#flexibilidade-conciliacao',
          intro: 'Aqui você deve selecionar a flexibilidade da sua conciliação.',
          scrollTo: 'tooltip',
          position: 'right'
        },
        {
          element: '#dialog-flexibilidade-conciliacao',
          intro: 'Você pode clicar aqui para obter mais informações sobre o impacto da flexibilidade na sua conciliação.',
          scrollTo: 'tooltip',
          position: 'right'
        },
        {
          element: '#conciliacao-editar-prioridades',
          intro:
            'Aqui você pode selecionar e alterar a ordem de Prioridade da sua conciliação, que é responsavel por gerar as rodadas.<br>Dica: você pode clicar e arrastar para alterar a ordem.',
          scrollTo: 'tooltip',
          position: 'right'
        },
        {
          element: '#conciliacao-editar-rodadas',
          intro:
            'Aqui você pode gerenciar as rodadas da sua conciliação.<br>Dica: você pode clicar e arrastar para alterar a ordem das rodadas.',
          scrollTo: 'tooltip',
          position: 'right'
        },
        {
          element: '#conciliacao-atributos-coringa',
          intro:
            'Aqui você pode escolher se sua conciliação habilitará Atributos Coringa.<br>Caso habilitado, irá considerar atributos vazios/invalidados ou iguais nas duas bases, caso contrário, apenas iguais em ambas as bases',
          scrollTo: 'tooltip',
          position: 'left'
        },
        {
          element: '#conciliacao-atributos-coringa-help',
          intro: 'Caso tenha dúvidas sobre os Atributos Coringa, clique aqui pode clicar aqui para maiores detalhes.',
          scrollTo: 'tooltip',
          position: 'left'
        }
      ],
      arrSegundaTabTour: [
        {
          element: '#conciliacao-base-de-partida',
          intro: 'Aqui você deve preencher as informações da base de dados de <b>Partida</b> da sua conciliação.',
          scrollTo: 'tooltip'
        },
        {
          element: '#conciliacao-editar-mapeamento-partida',
          intro: 'Aqui você deve mapear a base <b>Partida</b>. Os atributos selecionados nas rodadas são obrigatórios.',
          scrollTo: 'tooltip'
        }
      ],
      arrTerceiraTabTour: [
        {
          element: '#conciliacao-base-de-referencia',
          intro: 'Aqui você deve preencher as informações da base de dados de <b>Referência</b> da sua conciliação.',
          scrollTo: 'tooltip'
        },
        {
          element: '#conciliacao-editar-mapeamento-referencia',
          intro: 'Aqui você deve mapear a base <b>Referência</b>. Os atributos selecionados nas rodadas são obrigatórios.',
          scrollTo: 'tooltip'
        }
      ],
      arrQuartaTabTour: [
        {
          element: '#tempo-estimado-conciliacao-container',
          intro:
            'Aqui você pode verificar o tempo <b>estimado</b> para a execução da conciliação com os parametros selecionados.',
          scrollTo: 'tooltip',
          position: 'right'
        },
        {
          element: '#btn-save-conciliacao',
          intro: 'Após seleção dos critérios anteriores clique aqui para salvar e executar sua conciliação.',
          scrollTo: 'tooltip',
          position: 'left'
        }
      ]
    };
  },

  computed: {
    user() {
      return this.$store.getters.getUser;
    }
  },

  mounted() {
    this.iniciarPrimeiraTabTour();
  },

  methods: {
    getDefaultPartidaReferencia() {
      return {
        origem: 'Arquivo',
        consultaId: '',
        consultaNome: '',
        arquivo: undefined,
        arquivoId: '',
        headerValido: false,
        uploading: false,
        delimitador: ';',
        involucro: '"',
        escape: '"',
        fakeFile: false
      };
    },
    getCsvCamposPadroes() {
      ConfiguracoesService.getCsvCamposPadroes()
        .then((res) => {
          ['partida', 'referencia'].forEach((key) => {
            this.partidaReferencia[key].delimitador = res.data.campos.delimitador.valor;
            this.partidaReferencia[key].involucro = res.data.campos.involucro.valor;
            this.partidaReferencia[key].escape = res.data.campos.escape.valor;
          });
        })
        .catch((err) => {
          console.error('Erro ao recuperar campos padrões do arquivo csv: ', err);
          this.$toast.error('Erro ao recuperar campos padrões do arquivo csv.', '', { position: 'topRight' });
        });
    },
    getArquivoModelo() {
      ConciliacoesService.baixarArquivoModelo(this.tipoConciliacao)
        .then(async (res) => {
          this.$toast.info('Processando...', '', { position: 'topRight', timeout: 1500 });

          const url = window.URL.createObjectURL(new Blob([res.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', `Modelo Conciliação ${this.tipoConciliacao}.csv`);
          document.body.appendChild(link);
          link.click();
        })
        .catch((err) => {
          this.$toast.error('Erro ao baixar arquivo modelo', '', { position: 'topRight' });
          console.error(err);
        });
    },
    uploadNewFile(campos) {
      if (!campos.arquivo) return;

      campos.fakeFile = false;
      campos.arquivoId = '';
      campos.uploading = true;

      let data = new FormData();
      data.append('file', campos.arquivo);

      ArquivosService.uploadFile(data)
        .then((response) => {
          campos.arquivoId = response.data.arquivoId;
          this.validarHeader(response.data.arquivoId, campos);
        })
        .catch((err) => {
          console.error(err);

          if (err?.data?.cod_erro == 10000) {
            let msg = 'Há mais de um arquido dentro do ZIP.<br>Adicione apenas um arquivo CSV.';
            this.$toast.error(msg, '', { position: 'topRight', timeout: 8000 });
          } else {
            this.$toast.error('Erro no upload do arquivo.', '', { position: 'topRight' });
          }

          campos.arquivo = undefined;
        })
        .finally(() => {
          campos.uploading = false;
        });
    },
    setRelatorio(event) {
      const key = this.tab == 1 ? 'partida' : 'referencia';

      this.validarHeader(event.id, this.partidaReferencia[key]);

      this.partidaReferencia[key].consultaId = event.id;
      this.partidaReferencia[key].consultaNome = `#${event.id} - ${event.nome}`;

      this.relatoriosDialog = false;
    },
    validarHeader(id, campos) {
      const postData = {
        tipoConciliacao: this.tipoConciliacao,
        origem: campos.origem,
        delimitador: campos.delimitador,
        involucro: campos.involucro,
        escape: campos.escape,
        base: this.tab == 1 ? 'partida' : 'referência'
      };

      ConciliacoesService.validaHeader(id, postData)
        .then(() => {
          campos.headerValido = true;
        })
        .catch((err) => {
          let msg = '';
          if (err && err.data && err.data.erro_1) {
            msg = err.data.erro_1;
            if (campos.origem == 'Arquivo' && err.data.erro_2) msg += `<br>${err.data.erro_2}`;
          } else {
            msg = `Erro ao verificar colunas do(a) ${campos.origem}.`;
          }

          this.$toast.error(msg, '', { position: 'topRight', timeout: 5000 });
          console.error(err);

          campos.headerValido = false;
          campos.arquivo = undefined;
          campos.arquivoId = '';
          campos.consultaNome = '';
          campos.consultaId = '';
        });
    },
    fillFields() {
      const item = this.conciliacao;
      item.parametros = JSON.parse(item.parametros);

      this.titulo = item.nome;
      this.tucSelecionada = item.tuc_selecionada;
      this.flexibilidade = item.flexibilidade;
      this.rodadas = item.parametros?.rodadas
        ? item.parametros.rodadas.map((rodada) => {
            return { key: randomString(20), valores: rodada };
          })
        : [{ key: randomString(20), valores: ['TUC'] }];

      this.prioridades = item.parametros.prioridadeBusca;
      this.atributosList = [
        ...this.prioridades.filter((atrib) => atrib != 'TUC'),
        ...this.atributosList.filter((atrib) => !this.prioridades.includes(atrib))
      ];
      this.atributosCoringa = item.parametros.vazio == 'DIFNAN' ? true : false;

      this.partidaReferencia = {
        partida: {
          origem: item.origem_dados_contabil,
          consultaId: item.consulta_contabil_id,
          consultaNome: item.origem_dados_contabil == 'Consulta' && item.consulta_contabil ? item.consulta_contabil.nome : '',
          arquivo:
            item.origem_dados_contabil == 'Arquivo' && item.arquivo_contabil
              ? this.getFakeFileForValidation(item.arquivo_contabil.arquivo)
              : undefined,
          arquivoId: item.arquivo_contabil_id,
          headerValido: true,
          uploading: false,
          delimitador: item.arquivo_contabil_delimitador,
          involucro: item.arquivo_contabil_involucro,
          escape: item.arquivo_contabil_escape,
          fakeFile: item.origem_dados_contabil == 'Arquivo' ? true : false
        },
        referencia: {
          origem: item.origem_dados_fisico,
          consultaId: item.consulta_fisico_id,
          consultaNome: item.origem_dados_fisico == 'Consulta' && item.consulta_fisico ? item.consulta_fisico.nome : '',
          arquivo:
            item.origem_dados_fisico == 'Arquivo' && item.arquivo_fisico
              ? this.getFakeFileForValidation(item.arquivo_fisico.arquivo)
              : undefined,
          arquivoId: item.arquivo_fisico_id,
          headerValido: true,
          uploading: false,
          delimitador: item.arquivo_fisico_delimitador,
          involucro: item.arquivo_fisico_involucro,
          escape: item.arquivo_fisico_escape,
          fakeFile: item.origem_dados_fisico == 'Arquivo' ? true : false
        }
      };
    },
    getFakeFileForValidation(nomeArquivo) {
      return new File([''], nomeArquivo, { type: 'text/csv' });
    },
    iniciarPrimeiraTabTour() {
      this.doneLabel = 'Proximo';
      this.desativarTourAoSair = false;

      let onBeforeExitFunction = {
        func: () => {
          (this.$emit('update:tab', 1), this.iniciarSegundaTabTour());
        }
      };

      let init = () => {};
      if (this.tipoConciliacao == 'Express') {
        init = () => (this.panels = [0, 1]);
      } else {
        this.arrPrimeiraTabTour.splice(1, 1);
        this.arrPrimeiraTabTour.splice(3, 1);
      }

      this.iniciarTour(this.arrPrimeiraTabTour, [], [init], [onBeforeExitFunction]);
    },
    iniciarSegundaTabTour() {
      this.doneLabel = 'Proximo';
      this.desativarTourAoSair = false;

      let onBeforeExitFunction = {
        func: () => {
          (this.$emit('update:tab', 2), this.initTourThirdTab());
        }
      };

      let init = () => {};
      if (this.tipoConciliacao == 'Express') {
        this.arrSegundaTabTour.splice(1, 1);
      } else {
        init = () => {
          ['partida', 'referencia'].forEach((key) => {
            this.partidaReferencia[key].panels = 0;
          });
        };
      }

      this.iniciarTour(this.arrSegundaTabTour, [], [init], [onBeforeExitFunction]);
    },
    initTourThirdTab() {
      this.doneLabel = 'Próximo';
      this.desativarTourAoSair = false;

      let onBeforeExitFunction = {
        func: () => {
          this.$emit('update:tab', 3);
          this.initTourFourthTab();
        }
      };

      let init = () => {};
      if (this.tipoConciliacao == 'Express') {
        this.arrTerceiraTabTour.splice(1, 1);
      } else {
        init = () => {
          ['partida', 'referencia'].forEach((key) => {
            this.partidaReferencia[key].panels = 0;
          });
        };
      }

      this.iniciarTour(this.arrTerceiraTabTour, [], [init], [onBeforeExitFunction]);
    },
    initTourFourthTab() {
      this.mockTempoEstimadoTour = true;
      this.doneLabel = 'Finalizar';
      this.desativarTourAoSair = true;

      let onBeforeExitFunction = {
        func: () => {
          this.$emit('update:tab', 0);
          this.mockTempoEstimadoTour = false;
        }
      };

      this.iniciarTour(this.arrQuartaTabTour, [], [], [onBeforeExitFunction]);
    },
    getDadosConciliacao() {
      const partida = this.partidaReferencia.partida;
      const referencia = this.partidaReferencia.referencia;
      let regra = {};
      let vars = {};
      let prioridadeOrdenacao = this.prioridades;

      const rodadas = this.rodadas.map((rodada) => rodada.valores);
      const atributos = Array.from(new Set([].concat.apply([], rodadas)));

      // Definindo parametros de DATA_CONEXAO
      if (this.tipoConciliacao === 'Express' || (this.tipoConciliacao === 'Custom' && this.prioridades.includes('Data'))) {
        regra = {
          var: 'DATA_CONEXAO_ORDENACAO',
          tipo: 'ALL'
        };
        vars = {
          DATA_CONEXAO_ORDENACAO: {
            partida: 'Data',
            referencia: 'DATA_CONEXAO'
          }
        };

        if (!prioridadeOrdenacao.includes('Data')) {
          prioridadeOrdenacao.push('Data');
        }
        prioridadeOrdenacao.push('DATA_CONEXAO_ORDENACAO');
      }

      // Exceções de atributos na prioridadeOrdenacao
      prioridadeOrdenacao = prioridadeOrdenacao.filter(
        (atrib) =>
          ![
            'ODI',
            'TI',
            'UAR',
            'IDUC',
            'Inventario',
            'Obra',
            'Material',
            'Generico_1',
            'Generico_2',
            'Generico_3',
            'Periodo'
          ].includes(atrib)
      );

      return {
        nome: this.titulo,
        tuc_selecionada: this.tucSelecionada,
        tipo_conciliacao: this.tipoConciliacao,
        flexibilidade: this.flexibilidade,
        numero_rodadas: this.rodadas.length,

        origem_dados_contabil: partida.origem,
        consulta_contabil_id: partida.origem == 'Consulta' ? partida.consultaId : '',
        arquivo_contabil_id: partida.origem == 'Arquivo' ? partida.arquivoId : '',
        arquivo_contabil_delimitador: partida.delimitador,
        arquivo_contabil_involucro: partida.involucro,
        arquivo_contabil_escape: partida.escape,
        mapeamento_contabil: partida.mapeamento ? partida.mapeamento : {},

        origem_dados_fisico: referencia.origem,
        consulta_fisico_id: referencia.origem == 'Consulta' ? referencia.consultaId : '',
        arquivo_fisico_id: referencia.origem == 'Arquivo' ? referencia.arquivoId : '',
        arquivo_fisico_delimitador: referencia.delimitador,
        arquivo_fisico_involucro: referencia.involucro,
        arquivo_fisico_escape: referencia.escape,
        mapeamento_fisico: referencia.mapeamento ? referencia.mapeamento : {},

        parametros: {
          tipo: this.getParametroTipo(atributos),
          vars: vars,
          rodadas: rodadas,
          regra: regra,
          prioridadeBusca: atributos,
          prioridadeOrdenacao: prioridadeOrdenacao,
          flexibilidadeConciliacao: this.getParametrosFlexibilidade(this.flexibilidade),
          vazio: this.atributosCoringa ? 'DIFNAN' : 'TODOS'
        }
      };
    },
    getParametroTipo(atributos) {
      // Adicionando parametros fixos
      let tipo = { float: ['QTD'] };
      if (this.tipoConciliacao === 'Express') {
        tipo = {
          float: ['QTD'],
          data: ['Data', 'DATA_CONEXAO'],
          str: ['Periodo']
        };
      } else if (this.tipoConciliacao === 'Custom' && atributos.includes('Data')) {
        tipo = {
          float: ['QTD'],
          data: ['Data', 'DATA_CONEXAO']
        };
      }

      const tiposList = {
        ODI: 'str',
        TUC: 'float',
        A1: 'float',
        A2: 'float',
        A3: 'float',
        A4: 'float',
        A5: 'float',
        A6: 'float',
        TI: 'float',
        Data: 'data',
        DATA_CONEXAO: 'data',
        Periodo: 'str'
      };

      atributos.forEach((atrib) => {
        const key = tiposList[atrib] ? tiposList[atrib] : 'str';
        tipo[key] = tipo[key] !== undefined ? [...tipo[key], atrib] : [atrib];
      });

      return tipo;
    },
    getParametrosFlexibilidade(flexibilidade) {
      const flexibilidades = {
        Flexível: { a: 'n', b: 'n' },
        Rígida: { a: '1', b: '1' },
        Parcial: { a: '1', b: 'n' }
      };

      return flexibilidades[flexibilidade];
    },
    getTempoEstimado() {
      if (this.mockTempoEstimadoTour) {
        this.tempoEstimado = 'Entre 1 e 3 horas';
        return;
      }
      this.tempoEstimado = 'Entre 1 e 3 horas';
      return;

      this.loading = true;

      const data = this.getDadosConciliacao();

      ConciliacoesService.getEstimativaTempo({
        numero_rodadas: data.numero_rodadas,
        flexibilidade: data.flexibilidade,
        parametros: data.parametros,
        origem_dados_contabil: data.origem_dados_contabil,
        arquivo_contabil_id: data.arquivo_contabil_id,
        origem_dados_fisico: data.origem_dados_fisico,
        arquivo_fisico_id: data.arquivo_fisico_id
      })
        .then(({ data }) => {
          this.tempoEstimado = data.tempoEstimado;
        })
        .catch((err) => {
          this.tempoEstimado = null;
          this.$toast.error('Erro ao obter tempo estimado de execução de conciliação', '', { position: 'topRight' });
          console.error(err);
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
